import PropTypes from 'prop-types';
import cx from 'classnames';
import React, { PureComponent } from 'react';
import { DeferredImage } from './DeferredImage';
import css from './Image.scss';

export class Image extends PureComponent {
  constructor(...args) {
    super(...args);
    this.renderImage = this.renderImage.bind(this);
  }

  renderImage({ style, imageUrl, ref }) {
    const { alt, disablePreview, extraClass, previewSize, previewQuality, url, ...extraProps } = this.props;

    return (
      <img
        {...extraProps}
        className={cx(css.base, extraClass)}
        alt={alt}
        ref={ref}
        src={imageUrl || 'data:,'}
        style={style}
      />
    );
  }

  render() {
    const { disablePreview, previewSize, previewQuality, url } = this.props;

    return (
      <DeferredImage
        disablePreview={disablePreview}
        previewSize={previewSize}
        previewQuality={previewQuality}
        url={url}>
        {this.renderImage}
      </DeferredImage>
    );
  }
}

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  disablePreview: PropTypes.bool,
  extraClass: PropTypes.string,
  previewSize: PropTypes.number,
  previewQuality: PropTypes.number,
  url: PropTypes.string,
};
